export const DEFAULT_PARTNER_ORG_ID = '6d1e0952-da74-4199-8b58-bd7929f5069f';

// BuildShip device history endpoint (V2) — revert from V3 until the new Lovable API is deployed
export const DEVICE_HISTORY_API_URL =
  'https://api.snapshot.systems/deviceHistoryV2';